import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import {
    Label,
} from "flowbite-react";
import { Drawer } from "../../../../components/Modals";
import { useProjectService } from '../../../../services';

const EmailNotificationModal = ({
            showEmailNotificationModal,
            closeEmailNotificationModal,
            projectId
        }:any) =>{
        const [revokeSwitch, setRevokeSwitch] = useState({});
        
        const { 
            fetchProjectNotificationSetting,
            updateProjectNotificationSetting 
        } = useProjectService();

        const {
            notificationSettingLoading,
            notificationSettingData:nsd
        } = useSelector((state: any) => state.projects);

        useEffect(()=>{
            if(projectId){
                fetchProjectNotificationSetting(projectId)
            }
        },[projectId])

        const handleRevokeSwitch = async (e:any) => {
            const check =  e.target.checked;
            const name =  e.target.name;
            const payload:any  = {...revokeSwitch}
            if(check){
                setRevokeSwitch({...revokeSwitch,[name]:true});
                payload[name] = true
            } else {
                setRevokeSwitch({...revokeSwitch,[name]:false});
                payload[name] = false
            }
            updateProjectNotificationSetting(projectId,payload)
        }

        useEffect(()=>{
            setRevokeSwitch({...nsd})
        },[nsd])

        const settingKeyMapping:any  = {
            project_summary:"Status Report",
            task_updates:"Task Updates",
        }
        
    return (
        <Drawer
          isOpen={showEmailNotificationModal}
          onClose={closeEmailNotificationModal}
          position="right"
        >
            <div className="relative h-[calc(100%-55px)] overflow-auto flex flex-col">
                <div className={`flex flex-row border-b  !p-6 dark:border-gray-600 border-gray-200  dark:bg-[#111928] sticky top-0 z-40`}>
                    <div className="flex w-full h-12 items-center  ">
                        <div className="dark:text-white text-gray-700 text-lg font-bold font-['Inter'] truncate overflow-hidden w-72" title='View History'>Enable Notifications</div>
                        <button type="button" className="ml-auto absolute right-[10px] top-0 dark:text-white text-gray-700 w-6 h-6 rounded-full bg-black text-sm z-40" onClick={closeEmailNotificationModal}>
                            X
                        </button>
                    </div>
                </div>
                {notificationSettingLoading ? (
                    <div className="flex items-center flex-col justify-center w-full h-[100vh] bottom-0 relative">
                        {/* <Spinner aria-label="Center-aligned spinner example" /> */}
                        <img loading={"lazy"} alt="cadence Loader" className="w-40 mb-1" src="https://cadence-fe-bucket.s3.us-east-2.amazonaws.com/images/loader.gif" />
                        <div className="text-center dark:text-white opacity-50 text-base font-normal">Cadence is working<br />on your request</div>
                        <div className="absolute opacity-50 dark:bg-slate-900 top-0 right-0 left-0 bottom-0"></div>
                    </div>
                ) : 
                <div className="p-8 flex-col flex  ">
                    {Object.keys(nsd).map((item)=>{
                        return (
                            <div key={item} className="flex gap-5 items-center mb-4">
                                <Label>
                                    {settingKeyMapping[item]}
                                </Label>
                                {/* <div className="flex items-center">{settingKeyMapping[item]}</div> */}
                                <div className="button r notification switchToggle ml-auto">
                                    <input 
                                        type="checkbox"
                                        checked={revokeSwitch[item]}
                                        defaultValue={revokeSwitch[item]} 
                                        onChange={handleRevokeSwitch} 
                                        name={item}
                                        className="checkbox" />
                                    <div className="knobs"></div>
                                    <div className="layer"></div>
                                </div>
                            </div>
                        )
                    })}
                </div>
                }
            </div>
        </Drawer>
    )
}

export default EmailNotificationModal;